import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWebProtectionFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.326 6.845h-.063a.75.75 0 0 1 0-1.5c.414 0 .781.336.781.75s-.304.75-.718.75m-2.486 0h-.063a.75.75 0 0 1 0-1.5c.414 0 .781.336.781.75s-.304.75-.718.75m-2.486 0h-.063a.75.75 0 0 1 0-1.5c.414 0 .782.336.782.75s-.305.75-.719.75m15.146.73c0-3.307-2.123-5.53-5.282-5.53H7.783c-3.16 0-5.283 2.223-5.283 5.53v.41a.3.3 0 0 0 .3.3h18.4a.3.3 0 0 0 .3-.3zM11.941 15.942c-.02-1.02-.038-1.9.861-2.827.892-.886 3.91-1.819 4.79-1.819.61 0 2.233.447 3.463 1.004.205.093.445-.054.445-.28v-1.934a.3.3 0 0 0-.3-.3H2.8a.3.3 0 0 0-.3.3v5.44c0 3.302 2.123 5.52 5.282 5.52h4.729c.248 0 .393-.288.263-.5a5.45 5.45 0 0 1-.814-2.9c0-.795-.01-1.332-.019-1.704"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.994 15.88c-.007.386-.019.943-.019 1.765 0 1.67-1.757 2.515-2.383 2.763-.625-.248-2.383-1.092-2.383-2.763 0-.825-.01-1.383-.019-1.77-.005-.232-.01-.39-.009-.502.506-.25 2.084-.794 2.385-.83.357.037 2.002.606 2.438.822.001.114-.005.274-.01.515m1.123-1.558c-.436-.432-2.997-1.277-3.525-1.277s-3.088.845-3.534 1.287c-.39.403-.385.675-.367 1.574.007.38.018.928.018 1.739 0 3.14 3.518 4.234 3.667 4.279a.8.8 0 0 0 .432 0c.15-.045 3.667-1.138 3.667-4.28 0-.807.011-1.355.02-1.735.017-.924.022-1.173-.378-1.587"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWebProtectionFilled);
export default ForwardRef;
